import AlertAdd from "./AlertAdd";

export default function EditStock({
  formBuyingValidation,
  buyPriceAdd,
  buyQuantityAdd,
  addStockId,
  buyNumberAdd,
  buyNewQnty,
  buyNewPrice,
  buyNewTotal,
  buyNewQntyPrice,
  calcNewAdd,
  handleUpdatedQnty,
  buyNewQntyPriceVat,
  buyNewFinalTotal,
}) {
  const addStockValidation = () => {
    if (document.getElementById("addingModalSuccess")) {
      document.getElementById("addingModalSuccess").classList.add("d-none");
    }
    if (!buyNewQnty.current.value) {
      document.getElementById("AddStockqtyMessage").classList.remove("d-none");
      document
        .getElementById("AddStockqtyInput")
        .classList.add("border", "border-danger");
      return false;
    } else {
      document.getElementById("AddStockqtyMessage").classList.add("d-none");
      document
        .getElementById("AddStockqtyInput")
        .classList.remove("border", "border-danger");
    }
    if (!buyNewPrice.current.value) {
      document
        .getElementById("AddStockPriceMessage")
        .classList.remove("d-none");
      document
        .getElementById("AddStockPrice")
        .classList.add("border", "border-danger");
      return false;
    } else {
      document.getElementById("AddStockPriceMessage").classList.add("d-none");
      document
        .getElementById("AddStockPrice")
        .classList.remove("border", "border-danger");
    }
  };

  return (
    <>
      <div
        className="modal fade text-right"
        id="addStock"
        tabIndex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5
                className="modal-title text-dark d-flex align-items-center"
                id="exampleModalLabel"
              >
                اضافة اسهم
                <small className="d-flex align-items-center pr-2" id="addTitle">
                  {" "}
                </small>
              </h5>
              <button
                type="button"
                className="close ml-0"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <AlertAdd />
            <div className="modal-body">
              <form>
                <div className="form-row">
                  <div className="form-group col-md-4">
                    <label htmlFor="inputPassword3" className="text-dark ">
                      الكميه
                    </label>
                    <input
                      type="number"
                      id="AddStockqtyInput"
                      ref={buyNewQnty}
                      onChange={() => {
                        calcNewAdd();
                        addStockValidation();
                      }}
                      className="form-control"
                    ></input>
                    <small
                      className="text-danger d-none"
                      id="AddStockqtyMessage"
                    >
                      يرجى اضافة الكمية
                    </small>
                  </div>
                  <div className="form-group col-md-4">
                    <label htmlFor="inputPassword3" className="text-dark">
                      سعر السهم
                    </label>
                    <input
                      ref={buyNewPrice}
                      onChange={() => {
                        calcNewAdd();
                        addStockValidation();
                      }}
                      type="number"
                      step=".01"
                      id="AddStockPrice"
                      className="form-control"
                    ></input>
                    <small
                      className="text-danger d-none"
                      id="AddStockPriceMessage"
                    >
                      يرجى اضافة السعر
                    </small>
                  </div>
                  <div className="form-group col-md-4">
                    <label htmlFor="inputPassword3" className="text-dark ">
                      الاجمالي <small>(مع العمولة)</small>
                    </label>
                    <input
                      ref={buyNewTotal}
                      type="number"
                      disabled
                      className="form-control"
                    ></input>
                  </div>
                  <div className="form-group col-md-4">
                    <label htmlFor="inputPassword3" className="text-dark ">
                      تكلفة السهم السابقة
                    </label>
                    <input
                      type="hidden"
                      className="form-control"
                      ref={addStockId}
                    ></input>
                    <input
                      ref={buyPriceAdd}
                      type="number"
                      disabled
                      className="form-control"
                    ></input>
                  </div>
                  <div className="form-group col-md-4">
                    <label htmlFor="inputPassword3" className="text-dark ">
                      تكلفة السهم الجديدة
                    </label>
                    <input
                      ref={buyNewQntyPrice}
                      type="number"
                      disabled
                      className="form-control"
                    ></input>
                  </div>
                  <div className="form-group col-md-4">
                    <label htmlFor="inputPassword3" className="text-dark ">
                      الاجمالي
                    </label>
                    <input
                      ref={buyNewFinalTotal}
                      type="number"
                      disabled
                      className="form-control"
                    ></input>
                  </div>
                </div>
              </form>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => {
                  handleUpdatedQnty(addStockValidation);
                }}
                // data-dismiss="modal"
              >
                حفظ
              </button>
              <button
                type="button"
                className="btn btn-secondary"
                data-dismiss="modal"
              >
                الغاء
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
